export default "__VITE_ASSET__d30fbd0e__"